import { Component, Inject }                      from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA }                    from '@angular/material';
import { Globals }                        from './../common/globals';

@Component({
  selector: 'sa-train-part-dialog',
  template: require('./train-part-dialog.component.html'),
  styles: [require('./train-part-dialog.component.scss')]
})
export class TrainPartDialogComponent {
  public model: any;
  public newItem: boolean;
  public companies: any[];
  public canDelete = true;

  public errors = [];
  constructor(
    public dialogRef: MatDialogRef<TrainPartDialogComponent>,
    public globals: Globals,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (!!this.data.row) {
      this.model = JSON.parse(JSON.stringify(data.row));
    } else {
      this.model = {};
    }
    
    this.companies = data.companies;
    this.canDelete = !!data.canDelete;
  }

  public updateCompanyName($event) {
    // just to replace company name in paret dialog
    this.model.companyName = this.companies.find(c => c.companyUid === this.model.companyUid).name;
  }

  save() {
    this.errors = [];
    if (this.model.code === null || !this.model.code || this.model.code.trim().length === 0 ) {
        this.errors.push('Kód části spoje nesmí být prázdný');
    }

    if (this.model.companyUid === null || !this.model.companyUid || this.model.companyUid.trim().length === 0 ) {
      this.errors.push('Společnost nesmí být prázdná');
  }
    if (this.errors.length === 0) {
      this.dialogRef.close({
        action: 'save',
        model: this.model
      });
    }
  }

  delete() {
    if (confirm('Opravdu si přejete odstranit tento záznam?')) {
      this.dialogRef.close({
        action: 'delete',
        model: this.data
      });
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/train-part-dialog/train-part-dialog.component.ts